import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfFormIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * CcfFormIcon used to disply Form Management icon
 * @param props - CcfFormIconProps
 * @example -- <CcfFormIcon />
 */
export function CcfFormIcon(props: CcfFormIconProps) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M12.2496 5.6V12.18C12.2496 12.46 12.2496 12.6 11.9696 12.6H1.81961C1.53961 12.6 1.74961 12.46 1.74961 12.18V1.82C1.74961 1.54 1.53961 1.4 1.81961 1.4H8.04961V0H1.74961C0.629609 0 0.349609 0.28 0.349609 1.4V12.18C0.349609 13.02 0.629609 14 1.74961 14H11.8996C13.0196 14 13.6496 13.44 13.6496 12.32V5.6H12.2496Z"
        fill={props.fillColor ? props.fillColor : '#0079BA'}
      />
      <path
        d="M9.44961 4.9H12.9496C13.6496 4.9 13.7196 4.2 13.5096 4.06L9.37961 0.14C9.16961 -0.07 8.74961 2.08616e-08 8.74961 0.21V4.34C8.74961 4.48 8.74961 4.9 9.44961 4.9Z"
        fill={props.fillColor ? props.fillColor : '#0079BA'}
      />
      <path
        d="M3.84961 4.9H6.64961C7.06961 4.9 7.34961 4.62 7.34961 4.2C7.34961 3.78 7.06961 3.5 6.64961 3.5H3.84961C3.42961 3.5 3.14961 3.78 3.14961 4.2C3.14961 4.62 3.42961 4.9 3.84961 4.9Z"
        fill={props.fillColor ? props.fillColor : '#0079BA'}
      />
      <path
        d="M10.1496 6.3H3.84961C3.42961 6.3 3.14961 6.58 3.14961 7C3.14961 7.42 3.42961 7.7 3.84961 7.7H10.1496C10.5696 7.7 10.8496 7.42 10.8496 7C10.8496 6.58 10.5696 6.3 10.1496 6.3Z"
        fill={props.fillColor ? props.fillColor : '#0079BA'}
      />
      <path
        d="M10.1496 9.1H3.84961C3.42961 9.1 3.14961 9.38 3.14961 9.8C3.14961 10.22 3.42961 10.5 3.84961 10.5H10.1496C10.5696 10.5 10.8496 10.22 10.8496 9.8C10.8496 9.38 10.5696 9.1 10.1496 9.1Z"
        fill={props.fillColor ? props.fillColor : '#0079BA'}
      />
    </SvgIcon>
  );
}

export default CcfFormIcon;
